import React from 'react'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import Footer from '../../common/Footer'
import DynamicTourSection from '../../sections/CommonSection/DynamicToureSection'
import { mysoreOotyCoonoorData } from './tourPackageData'

const MysoreOotyCoonoor = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Mysore Ooty Coonoor" />
            <CommonBreadcrumb items={["Mysore Ooty Coonoor"]} />
            <DynamicTourSection {...mysoreOotyCoonoorData} />
            <Footer />
        </>
    )
}

export default MysoreOotyCoonoor